import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import BenefitsSection from './components/BenefitsSection';
import SeoContent from './components/SeoContent';
import PlatformsSection from './components/PlatformsSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://yoybuy.life';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Yoybuy Spreadsheet',
  url: SITE_URL,
  description: 'Yoybuy Spreadsheet 2026: лучшие таблицы товаров для Taobao, Weidian и 1688 с доставкой в Россию',
  inLanguage: 'ru',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Yoybuy Spreadsheet',
  url: SITE_URL,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <main>
        <Navbar />
        <HeroSection />
        <CategorySection />
        <BenefitsSection />
        <SeoContent />
        <PlatformsSection />
        <FaqSection />
        <SiteFooter />
      </main>
    </>
  );
}